import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SystemService } from 'common/services/core-services/system.service';

@Component({
  selector: 'sm-ui-toolbar',
  templateUrl: './sm-ui-toolbar.component.html',
  styleUrls: ['./sm-ui-toolbar.component.scss']
})
export class SmUiToolbarComponent implements OnInit {
  @Input() form;
  @Input() btnProps;
  @Input() MetaModel: any = null;
  @Output() add = new EventEmitter<any>();
  @Output() res = new EventEmitter<any>();
  invalidFields: string[] = [];

  constructor(protected systemService: SystemService) {}


  ngOnInit(): void {
      
  }
  submit(form): void {
      this.add.emit(this.form.valid);
  }

  reset(form): void {
      this.res.emit(true);
  }

  showInvalidValues(event) {
    this.invalidFields = []
      const invalidValues = event;
      invalidValues.forEach((value: any) => {
          if (Object.keys(this.MetaModel.properties).includes(value)) {
              const label = this.MetaModel.properties[value].label;
              this.invalidFields.push('  ' + label + '  ');
          }
      });
  }
}
